<template src="../templates/normal_fcont_161.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import UseDesignPaperList from '../components/UseDesignPaperList'
import CreatorProfileItsuka from '../components/CreatorProfileItsuka'
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import CreatorProfileGoTomochika from '../components/CreatorProfileGoTomochika'
import AppDownloadiPrint from '../components/AppDownloadiPrint'
import AppDownloadSmartPanel from '../components/AppDownloadSmartPanel'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,
    UseDesignPaperList,CreatorProfileItsuka,InfoMachineTranslation,
    CreatorProfileGoTomochika,AppDownloadiPrint,AppDownloadSmartPanel
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['161-1'],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['161-3']}
      ]
    };
  }
  
};
</script>
<style scoped>
</style>

